import {employeeActionTypes} from "../actions/actionTypes";

const initialState = {
	autoApproveDate: null,
	changeExplanationCopy: null,
	coverageEffectiveDate: null,
	coverageImpacted: null,
	decisionDate: null,
	status: null,
	dateOfBirth: null,
	declineCoverage: null,
	electionsMade: null,
	openEnrollmentStartDate: null,
	openEnrollmentEndDate: null,
}

export function birthAdoptionDetailsReducer(state= initialState, action) {
	const {type, payload} = action;
	switch(type) {
		case employeeActionTypes.SET_BIRTH_ADOPTION_DETAILS:
			return {
				...state,
				...payload
			}
		default:
			return state;
	}
}